import "../assets/Steps.css";
import { h as Re, defineComponent as R, ref as k, computed as s, onMounted as W, openBlock as f, createElementBlock as S, normalizeStyle as A, createVNode as M, Fragment as Z, renderList as te, normalizeClass as ve, unref as l, createCommentVNode as j, createElementVNode as v, useCssVars as he, inject as xe, watchEffect as ke, onBeforeUnmount as De, toDisplayString as C, defineAsyncComponent as Fe, createBlock as _e, mergeProps as G, toRaw as He, isRef as pe, withKeys as ge, withModifiers as fe, renderSlot as qe, nextTick as Be, withCtx as Ve, createTextVNode as Ie, watch as Ke, Transition as Ee, resolveDynamicComponent as Ae } from "vue";
import { e as V, A as ae, T as Me, P as ze, D as Te, o as le, a as X, C as Ne, q as Oe, r as we, s as Ue, c as Ze, L as N, t as Y, g as se, b as Le } from "./maps.ChaVcqWI.js";
import { u as Ye } from "./index.72N0HVaZ.js";
import { p as je } from "./widgets-core.es.DdX21Kyh.js";
import { o as q, B as ie, e as H, l as We } from "./useStore.DvPy8fc7.js";
import { a as ne, _ as Pe, b as Ge, s as Je } from "./Text.vue_vue_type_style_index_0_lang.BEQZVGlu.js";
import { _ as ye } from "./Input.vue_vue_type_style_index_0_lang.CpepcVjg.js";
import { _ as be } from "./Terms.vue_vue_type_style_index_0_lang.Bd5xtNRj.js";
import { _ as Qe } from "./Tooltip.vue_vue_type_style_index_0_lang.CQgCKEVm.js";
import { _ as Se } from "./_plugin-vue_export-helper.CHgC5LLL.js";
const Xe = (t, e) => {
  const o = "http://www.w3.org/2000/svg", i = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M4.166 5a8.25 8.25 0 1111.668 11.667A8.25 8.25 0 014.166 4.999zM10 4.082a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm-.75 4.25a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75zm-.833 2.5a.75.75 0 01.75-.75H10a.75.75 0 01.75.75v2.583h.083a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75v-2.583h-.083a.75.75 0 01-.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (t.title) {
    const b = document.createElementNS(o, "title");
    b.textContent = t.title, i.appendChild(b);
  }
  const h = Array.from((i == null ? void 0 : i.attributes) ?? []).reduce((b, c) => ({
    ...b,
    [c.name]: c.value
  }));
  return Re(
    "svg",
    {
      ...h,
      ...e.attrs,
      role: "img",
      innerHTML: i.innerHTML
    }
  );
};
var ee = /* @__PURE__ */ ((t) => (t.Active = "active", t.Next = "next", t.Previous = "previous", t))(ee || {});
const et = ["data-module-id"], $e = /* @__PURE__ */ R({
  __name: "EmailCapture",
  props: {
    moduleProps: {}
  },
  setup(t) {
    const e = {
      [V.SavedSearch]: ae.SendSaveSearch,
      [V.EmailCapture]: ae.SendSubscribe
    }, o = q(), n = t, i = k(), h = k(null), b = k(""), c = s(() => {
      var u;
      return ((u = o == null ? void 0 : o.extraData.defaultAssets) == null ? void 0 : u.terms) || [];
    }), _ = s(() => n.moduleProps.terms.customTerms), w = s(() => n.moduleProps.terms.isTermRequired), L = s(
      () => n.moduleProps.terms.isTermsInheritedFromProperty
    ), r = s(() => o == null ? void 0 : o.literals.getLiteral("Please, provide a valid e-mail")), g = s(() => o == null ? void 0 : o.literals.getLiteral("Your email")), y = s(() => (o == null ? void 0 : o.handlers.buttonState) === ie.Sending), a = s(() => ne(n.moduleProps.appearance, o == null ? void 0 : o.device));
    function p() {
      if (i.value && h.value && i.value.validate()) {
        const m = h.value.validate();
        if (m.valid)
          return {
            emailAddress: b.value,
            terms: m.terms
          };
      }
      return !1;
    }
    return W(() => {
      o == null || o.handlers.setDataValidator(e[n.moduleProps.moduleType], p);
    }), (u, m) => (f(), S("div", {
      class: "thn--tool-emailcapture",
      "data-module-id": u.moduleProps.id,
      style: A(a.value)
    }, [
      M(ye, {
        class: "thn--tool-emailcapture__input",
        ref_key: "emailRef",
        ref: i,
        type: "email",
        modelValue: b.value,
        "onUpdate:modelValue": m[0] || (m[0] = (P) => b.value = P),
        placeholder: g.value,
        "error-message": r.value,
        disabled: !!y.value,
        required: !0,
        id: "email-capture"
      }, null, 8, ["modelValue", "placeholder", "error-message", "disabled"]),
      M(be, {
        class: "thn--tool-emailcapture__terms",
        ref_key: "termsRef",
        ref: h,
        disabled: !!y.value,
        "custom-terms": _.value,
        "property-terms": c.value,
        "terms-inherited": L.value,
        "terms-required": w.value,
        "appearance-style": a.value
      }, null, 8, ["disabled", "custom-terms", "property-terms", "terms-inherited", "terms-required", "appearance-style"])
    ], 12, et));
  }
}), tt = ["data-module-id"], at = {
  key: 0,
  class: "thn--tool-perks__bullet"
}, nt = { class: "thn--tool-perks__label" }, ot = ["innerHTML"], lt = ["onMouseover", "onMouseout"], st = /* @__PURE__ */ R({
  __name: "Perks",
  props: {
    moduleProps: {}
  },
  setup(t) {
    const e = q(), o = t, n = k({}), i = s(() => {
      var g;
      return ((g = e == null ? void 0 : e.styles.fonts.perks) == null ? void 0 : g.textTransform) === Me.Titlecase;
    }), h = s(() => ne(o.moduleProps.appearance, e == null ? void 0 : e.device)), b = s(() => o.moduleProps.isPerksInheritedFromProperty), c = s(() => {
      var r;
      return b.value ? (r = e == null ? void 0 : e.extraData.defaultAssets) == null ? void 0 : r.perks : o.moduleProps.perks;
    });
    function _(r, g) {
      var P;
      const y = (P = c.value) == null ? void 0 : P.find(($) => $.perkId === g), a = y && y.perk.tooltipInfo && (e == null ? void 0 : e.literals.getPerkTooltipLiteral(y.perk.tooltipInfo)), {
        left: p,
        top: u,
        width: m
      } = r.getBoundingClientRect();
      n.value[g].show(a, {
        left: p + m / 2,
        top: u
      });
    }
    function w(r) {
      return e && r.description ? e.literals.getPerkActiveLiteral(r.description, i.value) : r.name;
    }
    function L(r) {
      n.value[r].hide();
    }
    return (r, g) => (f(), S("ul", {
      class: "thn--tool-perks",
      "data-module-id": r.moduleProps.id,
      style: A(h.value)
    }, [
      (f(!0), S(Z, null, te(c.value, ({ perkId: y, perk: a }) => {
        var p, u;
        return f(), S("li", {
          class: ve({
            "thn--tool-perks__perk": !0,
            highlights: ((p = r.moduleProps.appearance) == null ? void 0 : p.layout) === "highlights"
          }),
          key: y
        }, [
          ((u = r.moduleProps.appearance) == null ? void 0 : u.layout) === l(ze).Bullets ? (f(), S("div", at)) : j("", !0),
          v("div", nt, [
            v("span", {
              class: "thn--tool-perks__label-text",
              innerHTML: w(a)
            }, null, 8, ot),
            a.tooltipInfo ? (f(), S("div", {
              key: 0,
              class: "thn--tool-perks__icon",
              onMouseover: (m) => _(m.target, y),
              onMouseout: () => L(y)
            }, [
              M(l(Xe)),
              M(Qe, {
                class: "thn--tool-perks__tooltip",
                ref_for: !0,
                ref: (m) => n.value[y] = m,
                "back-color": "#ffffff",
                color: "#000000"
              }, null, 512)
            ], 40, lt)) : j("", !0)
          ])
        ], 2);
      }), 128))
    ], 12, tt));
  }
}), z = {
  [Te.Desktop]: {
    [le.Compact]: {
      number: 14,
      label: 14
    },
    [le.Normal]: {
      number: 36,
      label: 14
    }
  },
  [Te.Mobile]: {
    [le.Compact]: {
      number: 14,
      label: 14
    },
    [le.Normal]: {
      number: 24,
      label: 12
    }
  }
}, it = ["data-module-id", "data-style", "data-size"], rt = { class: "thn--tool-countdown__number" }, ut = { class: "thn--tool-countdown__label" }, dt = ["title"], ct = { key: 1 }, mt = /* @__PURE__ */ R({
  __name: "Countdown",
  props: {
    moduleProps: {}
  },
  setup(t) {
    he((r) => ({
      "246bd40a": l(H)(l(z).desktop.normal.number),
      bfeb274c: l(H)(l(z).desktop.normal.label),
      "1548971a": l(H)(l(z).desktop.compact.number),
      "8de1c23c": l(H)(l(z).desktop.compact.label),
      "5314924e": l(H)(l(z).mobile.compact.number),
      "4dcf9088": l(H)(l(z).mobile.compact.label),
      "0dd32ed5": l(H)(l(z).mobile.normal.number),
      "0c6dd040": l(H)(l(z).mobile.normal.label)
    }));
    const e = q(), o = t, i = k({
      hours: "00",
      minutes: "00",
      seconds: "00"
    }), h = k(!0), b = k(), c = k(!1), _ = xe("layout"), w = s(() => {
      var r, g;
      return ((r = o.moduleProps.appearance) == null ? void 0 : r.size) === "compact" && ((g = _ == null ? void 0 : _.value) == null ? void 0 : g.type) === X.StickyImage;
    });
    ke(() => {
      const {
        type: r,
        details: g
      } = o.moduleProps, y = e != null && e.extraData.countdownTimestamp ? e == null ? void 0 : e.extraData.countdownTimestamp : (e == null ? void 0 : e.extraData.getCountdownTimestamp(r, g)) || Date.now(), {
        builderMode: a = !1,
        countdownInitTime: p = Date.now()
      } = (e == null ? void 0 : e.extraData) || {};
      c.value = a && r === Ne.Time, b.value = c.value ? y - p : y;
    });
    function L() {
      if (!h.value) {
        const r = Math.round((b.value - (c.value ? 0 : Date.now())) / 1e3), g = We(r);
        r > 0 ? (i.value = g, setTimeout(L, 200)) : i.value = g;
      }
    }
    return ke(L), W(() => {
      h.value = !1;
    }), De(() => {
      h.value = !0;
    }), (r, g) => {
      var y, a;
      return f(), S("div", {
        class: "thn--tool-countdown",
        "data-module-id": r.moduleProps.id,
        "data-style": (y = r.moduleProps.appearance) == null ? void 0 : y.style,
        "data-size": (a = r.moduleProps.appearance) == null ? void 0 : a.size
      }, [
        (f(!0), S(Z, null, te(i.value, (p, u) => {
          var m, P, $;
          return f(), S("div", {
            class: "thn--tool-countdown__block",
            key: u
          }, [
            v("p", rt, C(p), 1),
            v("div", ut, [
              w.value ? (f(), S("abbr", {
                key: 0,
                title: (m = l(e)) == null ? void 0 : m.literals.getLiteral(u)
              }, C((P = l(e)) == null ? void 0 : P.literals.getLiteralAbb(u)), 9, dt)) : (f(), S("span", ct, C(($ = l(e)) == null ? void 0 : $.literals.getLiteral(u)), 1))
            ])
          ]);
        }), 128))
      ], 8, it);
    };
  }
}), pt = ["data-module-id"], vt = /* @__PURE__ */ R({
  __name: "Form",
  props: {
    moduleProps: {}
  },
  setup(t) {
    const e = q(), o = t, n = k(null), i = k(), h = Fe(
      // @ts-ignore the lack of TS definitions for this package
      () => import("./form-viewer.common.CxdN1K21.js").then((u) => u.f)
    ), b = s(() => (e == null ? void 0 : e.handlers.buttonState) === ie.Sending), c = s(() => {
      var u;
      return (u = e == null ? void 0 : e.extraData.defaultAssets) == null ? void 0 : u.terms;
    }), _ = s(() => o.moduleProps.terms.customTerms), w = s(() => o.moduleProps.terms.isTermRequired), L = s(
      () => o.moduleProps.terms.isTermsInheritedFromProperty
    ), r = k([]), g = s(() => ne(o.moduleProps.appearance, e == null ? void 0 : e.device)), y = (u) => {
      r.value = u.values;
    }, a = s(() => {
      const {
        name: u,
        fields: m,
        fieldsPosition: P
      } = o.moduleProps, $ = P === Oe.Out ? 1 : 2;
      return {
        lang: e == null ? void 0 : e.language,
        data: {
          name: u,
          fields: m.map((B) => {
            const {
              id: O,
              type: I,
              labels: E,
              hiddenName: x,
              optional: d,
              options: T = [],
              selection: D = we.Single,
              defaultOption: re,
              popupPosition: ue
            } = B, de = T.map((J) => ({
              value: J.id,
              label: J.labels
            })), U = D === we.Multiple ? "multiSelection" : "oneSelection";
            return {
              type: I === Ue.Selection ? U : I,
              default: re,
              label: E,
              labelDisplay: x ? 0 : $,
              name: O,
              required: !d,
              options: de,
              popupPosition: ue
            };
          })
        }
      };
    });
    async function p() {
      if (i.value && n.value && (await i.value.formRef.validate()).valid) {
        const m = n.value.validate();
        if (m.valid)
          return {
            formFields: He(r.value),
            terms: m.terms
          };
      }
      return !1;
    }
    return W(() => {
      e == null || e.handlers.setDataValidator(ae.SendForm, p);
    }), (u, m) => (f(), S("form", {
      class: "thn--tool-form",
      style: A(g.value),
      "data-module-id": u.moduleProps.id
    }, [
      a.value ? (f(), _e(l(h), G({
        key: 0,
        class: "thn--tool-form__viewer",
        ref_key: "viewerRef",
        ref: i
      }, a.value, { onChange: y }), null, 16)) : j("", !0),
      M(be, {
        class: "thn--tool-form__terms",
        ref_key: "termsRef",
        ref: n,
        disabled: !!b.value,
        "custom-terms": _.value,
        "property-terms": c.value,
        "terms-inherited": L.value,
        "terms-required": w.value,
        "appearance-style": g.value
      }, null, 8, ["disabled", "custom-terms", "property-terms", "terms-inherited", "terms-required", "appearance-style"])
    ], 12, pt));
  }
}), ht = ["data-module-id"], _t = /* @__PURE__ */ R({
  __name: "Spacer",
  props: {
    moduleProps: {}
  },
  setup(t) {
    he((i) => ({
      "10c1ba4d": o.value,
      "6b41dc51": n.value
    }));
    const e = t, o = s(() => {
      var i;
      return `${((i = e.moduleProps.desktop) == null ? void 0 : i.space) || 0}px`;
    }), n = s(() => {
      var i;
      return `${((i = e.moduleProps.mobile) == null ? void 0 : i.space) || 0}px`;
    });
    return (i, h) => (f(), S("div", {
      role: "none",
      "data-module-id": i.moduleProps.id,
      class: "thn--tool-spacer"
    }, null, 8, ht));
  }
}), gt = k(!1), F = k(), ft = k(""), Ce = k(""), ce = k(!1), me = k(!1), oe = () => {
  const t = q(), e = k((/* @__PURE__ */ new Date()).getTime().toString()), o = t == null ? void 0 : t.literals.getLiteral("Invalid code"), n = s(() => (t == null ? void 0 : t.language) || "en"), i = s(() => {
    var d;
    return ne((d = F.value) == null ? void 0 : d.appearance, t == null ? void 0 : t.device);
  }), h = s(() => {
    const d = {
      label: t == null ? void 0 : t.literals.getLiteral("Privacy policy"),
      url: `https://www.thehotelsnetwork.com/${n.value}/instant-privacy-policy`
    };
    return `
      ${t == null ? void 0 : t.literals.getLiteral("I agree to the")} 
      <a href="${d.url}" target="_blank">${d.label}</a>
    `;
  }), b = s(() => {
    var d;
    return (d = t == null ? void 0 : t.extraData.defaultAssets) == null ? void 0 : d.terms;
  }), c = s(
    () => {
      var d, T;
      return (T = (d = F.value) == null ? void 0 : d.terms) == null ? void 0 : T.isTermsInheritedFromProperty;
    }
  ), _ = s(() => {
    var d, T;
    return [
      {
        termId: "instant-login-terms",
        isRequired: !0,
        term: {
          id: "instant-login-terms",
          name: "Instant Login Terms",
          isRequired: !0,
          content: {
            linkedTo: Ze.CustomUrl,
            htmlContent: h.value
          },
          properties: []
        }
      },
      ...((T = (d = F.value) == null ? void 0 : d.terms) == null ? void 0 : T.customTerms) || []
    ];
  }), w = s(() => {
    var d, T;
    return !!((T = (d = F.value) == null ? void 0 : d.terms) != null && T.isTermRequired);
  });
  let L;
  const r = s(() => {
    var d, T;
    return (d = F.value) != null && d.buttonModule && (L = (T = F.value) == null ? void 0 : T.buttonModule), L;
  }), g = s(() => {
    var d;
    return (d = r.value) == null ? void 0 : d.appearance;
  }), y = s(() => {
    var d;
    return ne((d = r.value) == null ? void 0 : d.appearance, t == null ? void 0 : t.device);
  }), a = k(N.LoginRegister), p = () => {
    Ce.value = "", me.value = !1, t == null || t.handlers.goBackToMainStep();
  }, u = (d) => {
    F.value = d, e.value = (/* @__PURE__ */ new Date()).getTime().toString(), a.value = d.currentView;
  }, m = (d) => {
    F.value = {
      ...F.value,
      ...d
    };
  };
  function P() {
    t == null || t.handlers.setStepActive(N.LoginSignin, se.Main);
  }
  function $() {
    p(), t == null || t.handlers.goBackToMainStep();
  }
  function B() {
    t == null || t.handlers.setStepActive(se.Failure);
  }
  function O() {
    p(), t == null || t.handlers.setStepActive(N.LoginSuccess);
  }
  function I() {
    ce.value = !0, ((t == null ? void 0 : t.handlers.stepActive) === N.LoginRegister || (t == null ? void 0 : t.handlers.stepActive) === se.Main) && (p(), P());
  }
  const E = {
    [Y.Signup]: $,
    [Y.Validation]: I
  };
  return {
    sending: gt,
    sessionId: e,
    emailValue: ft,
    currentStep: a,
    moduleProps: F,
    authCodeValue: Ce,
    validateError: o,
    showValidateError: me,
    isAuthCodeRequested: ce,
    termsArray: _,
    propertyTerms: b,
    isTermsRequired: w,
    buttonAppearance: g,
    buttonModule: r,
    buttonStyle: y,
    isTermsInheritedFromProperty: c,
    appearanceStyle: i,
    goToSignin: P,
    initModule: u,
    goToRegister: $,
    updateModule: m,
    doLoginAction: async (d) => {
      var D;
      if (!t) return;
      t.handlers.setDataValidator(ae.Login, d);
      const T = await t.handlers.callHandler(
        ae.Login,
        (D = F.value) == null ? void 0 : D.id
      );
      if (console.log("THN", "useLoginState", "doLoginAction", "result", T), !T || !T.ok) {
        t.handlers.stepActive === N.LoginSignin && ce.value ? me.value = !0 : B();
        return;
      }
      if (T.next) {
        E[T.next]();
        return;
      }
      O();
    }
  };
}, yt = { class: "thn--tool-register__form" }, bt = { class: "thn--tool-register__actions" }, St = ["data-full-width"], kt = ["innerHTML"], Tt = /* @__PURE__ */ R({
  __name: "Register",
  setup(t) {
    const e = q(), o = oe(), {
      emailValue: n,
      isTermsRequired: i,
      termsArray: h,
      appearanceStyle: b,
      propertyTerms: c,
      buttonModule: _,
      buttonStyle: w,
      buttonAppearance: L,
      isTermsInheritedFromProperty: r,
      goToSignin: g,
      doLoginAction: y
    } = o, a = k(), p = k(null), u = s(() => (e == null ? void 0 : e.handlers.buttonState) === ie.Sending || !1), m = s(() => (e == null ? void 0 : e.literals.getLiteral("Please, provide a valid e-mail")) || ""), P = s(() => e == null ? void 0 : e.literals.getLiteral("Your email")), $ = s(() => e == null ? void 0 : e.literals.getLiteral("Already registered?")), B = s(() => e == null ? void 0 : e.literals.getLiteral("Sign in")), O = s(() => {
      var x;
      return !_.value || !(e != null && e.device) ? "" : e == null ? void 0 : e.literals.getActiveModuleText(
        _.value,
        ((x = e == null ? void 0 : e.styles.fonts[V.Button]) == null ? void 0 : x.textTransform) === Me.Titlecase
      );
    });
    function I() {
      if (a.value && p.value && a.value.validate()) {
        const d = p.value.validate();
        if (d.valid)
          return {
            action: Y.Signup,
            emailAddress: n.value,
            terms: d.terms
          };
      }
      return !1;
    }
    async function E() {
      I() && y(I);
    }
    return (x, d) => {
      var T;
      return f(), S("div", G(x.$attrs, { class: "thn--tool-register" }), [
        v("div", yt, [
          M(ye, {
            class: "thn--tool-register__input",
            ref_key: "emailRef",
            ref: a,
            type: "email",
            modelValue: l(n),
            "onUpdate:modelValue": d[0] || (d[0] = (D) => pe(n) ? n.value = D : null),
            placeholder: P.value,
            "error-message": m.value,
            required: !0,
            style: A(l(b)),
            disabled: !!u.value,
            id: "register-email"
          }, null, 8, ["modelValue", "placeholder", "error-message", "style", "disabled"]),
          M(be, {
            class: "thn--tool-register__terms",
            ref_key: "termsRef",
            ref: p,
            "property-terms": l(c),
            "terms-required": l(i),
            disabled: !!u.value,
            "custom-terms": l(h),
            "terms-inherited": !!l(r),
            style: A(l(b))
          }, null, 8, ["property-terms", "terms-required", "disabled", "custom-terms", "terms-inherited", "style"])
        ]),
        v("div", bt, [
          v("div", {
            role: "button",
            tabindex: "0",
            class: "thn--tool-button",
            style: A(l(w)),
            "data-full-width": (T = l(L)) == null ? void 0 : T.fullWidth,
            onClick: E,
            onKeyup: ge(E, ["enter"])
          }, [
            d[2] || (d[2] = v("div", { class: "thn--tool-button__back" }, null, -1)),
            v("div", {
              class: "thn--tool-button__label",
              innerHTML: O.value
            }, null, 8, kt)
          ], 44, St),
          v("div", {
            class: "thn--tool-register__signin",
            style: A(l(b))
          }, [
            v("span", null, C($.value), 1),
            v("a", {
              href: "#",
              onClick: d[1] || (d[1] = fe(
                //@ts-ignore
                (...D) => l(g) && l(g)(...D),
                ["prevent", "stop"]
              ))
            }, C(B.value), 1)
          ], 4)
        ])
      ], 16);
    };
  }
}), wt = {};
function Lt(t, e) {
  return f(), S("svg", G({
    width: "8",
    height: "16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.$attrs), e[0] || (e[0] = [
    v("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.548 15.238a.381.381 0 0 0 .27-.65L1.23 8.001l6.587-6.588A.381.381 0 0 0 7.28.875L.42 7.732a.381.381 0 0 0 0 .538l6.858 6.858a.38.38 0 0 0 .27.11h-.001Z",
      fill: "currentColor"
    }, null, -1)
  ]), 16);
}
const Pt = /* @__PURE__ */ Se(wt, [["render", Lt]]), $t = {};
function Ct(t, e) {
  return f(), S("svg", G({
    width: "49",
    height: "48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.$attrs), e[0] || (e[0] = [
    v("rect", {
      x: ".5",
      width: "48",
      height: "48",
      rx: "24",
      fill: "#D9D9D9"
    }, null, -1),
    v("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.1 24.8a4.405 4.405 0 0 1-4.4-4.4c0-2.426 1.974-4.4 4.4-4.4s4.4 1.974 4.4 4.4-1.974 4.4-4.4 4.4Zm0-8a3.604 3.604 0 0 0-3.6 3.6c0 1.985 1.615 3.6 3.6 3.6s3.6-1.615 3.6-3.6-1.615-3.6-3.6-3.6ZM17.7 32c-.662 0-1.2-.538-1.2-1.2 0-.054.011-1.348.98-2.64.564-.752 1.336-1.35 2.295-1.775 1.171-.521 2.627-.785 4.325-.785 1.698 0 3.154.264 4.325.785.959.426 1.731 1.023 2.295 1.775.969 1.292.98 2.586.98 2.64 0 .662-.538 1.2-1.2 1.2H17.7Zm6.4-5.6c-2.79 0-4.848.762-5.953 2.205-.809 1.056-.845 2.135-.847 2.194v.003a.4.4 0 0 0 .4.398h12.8a.4.4 0 0 0 .4-.4c0-.01-.018-1.114-.847-2.195-1.106-1.443-3.164-2.205-5.953-2.205Z",
      fill: "#fff"
    }, null, -1)
  ]), 16);
}
const Vt = /* @__PURE__ */ Se($t, [["render", Ct]]), At = { class: "thn-tool--login__header-back" }, Mt = { class: "thn-tool--login__header-back--user-icon" }, Rt = { class: "thn-tool--login__header-back--email" }, xt = /* @__PURE__ */ R({
  __name: "HeaderBack",
  emits: ["goBack"],
  setup(t) {
    return (e, o) => (f(), S("div", At, [
      v("button", {
        type: "button",
        tabindex: "0",
        class: "thn-tool--login__header-back--button",
        onClick: o[0] || (o[0] = (n) => e.$emit("goBack")),
        onKeyup: o[1] || (o[1] = ge((n) => e.$emit("goBack"), ["enter"]))
      }, [
        M(Pt)
      ], 32),
      v("div", Mt, [
        M(Vt)
      ]),
      v("div", Rt, [
        qe(e.$slots, "default")
      ])
    ]));
  }
}), Dt = {
  key: 0,
  class: "thn--tool-signin__auth-code"
}, Ft = { class: "thn--tool-signin__auth-code__container" }, Ht = ["onInput"], qt = {
  key: 0,
  class: "thn--tool-signin__auth-code__validate-error"
}, Bt = /* @__PURE__ */ R({
  __name: "AuthCode",
  props: {
    modelValue: {}
  },
  emits: ["validate", "update:modelValue", "resendCode"],
  setup(t, { emit: e }) {
    const o = e, n = q(), i = oe(), {
      showValidateError: h,
      validateError: b
    } = i, c = k([]), _ = k(!1), w = s(() => n == null ? void 0 : n.literals.getLiteral("Resend code")), L = () => {
      if (c.value.every((p) => p.value.length === 1)) {
        const p = c.value.map((u) => u.value).join("");
        o("update:modelValue", p), o("validate", p);
      }
    }, r = (a) => {
      if (c.value[a - 1].value.length === 1)
        if (a < 6) {
          const u = c.value[a];
          u && u.focus();
        } else
          c.value[a - 1].blur(), L();
    }, g = (a) => {
      var u;
      const p = ((u = a.clipboardData) == null ? void 0 : u.getData("text")) ?? "";
      if (p.length > 0) {
        const m = p.slice(0, 6);
        c.value.forEach(async (P, $) => {
          P.value = m[$] ?? "", $ < c.value.length - 1 && (c.value[$ + 1].focus(), await Be(), c.value[$ + 1].setSelectionRange(0, 1));
        }), c.value[c.value.length - 1].blur(), L();
      }
    }, y = () => {
      c.value.forEach((a) => {
        a.value = "";
      }), h.value = !1, o("update:modelValue", ""), o("resendCode");
    };
    return W(() => {
      var a;
      _.value = !0, (a = c.value[0]) == null || a.focus();
    }), (a, p) => _.value ? (f(), S("div", Dt, [
      v("div", Ft, [
        (f(), S(Z, null, te(6, (u) => v("input", {
          tabindex: "0",
          ref_for: !0,
          ref_key: "inputRefs",
          ref: c,
          key: u,
          class: ve([
            "code-input",
            l(h) && "code-input--error"
          ]),
          maxlength: "1",
          type: "text",
          inputmode: "numeric",
          onFocus: p[0] || (p[0] = (m) => m.target.select()),
          onInput: (m) => r(u),
          onPaste: g,
          required: ""
        }, null, 42, Ht)), 64))
      ]),
      l(h) ? (f(), S("div", qt, C(l(b)), 1)) : j("", !0),
      v("a", {
        href: "#",
        onClick: fe(y, ["prevent"])
      }, C(w.value), 1)
    ])) : j("", !0);
  }
}), It = { class: "thn--tool-signin__heading" }, Kt = {
  role: "heading",
  "aria-level": "1"
}, Et = { class: "thn--tool-signin__form" }, zt = { class: "thn--tool-signin__actions" }, Nt = ["data-full-width"], Ot = { class: "thn--tool-button__label" }, Ut = { class: "thn--tool-signin__heading thn--tool-signin__heading--auth-code" }, Zt = {
  role: "heading",
  "aria-level": "1"
}, Yt = /* @__PURE__ */ R({
  __name: "Signin",
  setup(t) {
    const e = q(), o = oe(), {
      emailValue: n,
      buttonStyle: i,
      authCodeValue: h,
      buttonAppearance: b,
      isAuthCodeRequested: c,
      showValidateError: _,
      appearanceStyle: w,
      goToSignin: L,
      goToRegister: r,
      doLoginAction: g
    } = o, y = k(), a = k(!1), p = s(() => (e == null ? void 0 : e.handlers.buttonState) === ie.Sending), u = s(() => e == null ? void 0 : e.literals.getLiteral("Sign in to your account")), m = s(() => e == null ? void 0 : e.literals.getLiteral("Please, provide a valid e-mail")), P = s(() => e == null ? void 0 : e.literals.getLiteral("Your email")), $ = s(() => e == null ? void 0 : e.literals.getLiteral("Not registered yet?")), B = s(() => e == null ? void 0 : e.literals.getLiteral("Register")), O = s(() => e == null ? void 0 : e.literals.getLiteral("Sign in")), I = s(() => e == null ? void 0 : e.literals.getLiteral("Confirm your email")), E = s(() => e == null ? void 0 : e.literals.getLiteral("Enter the validation code sent to your email"));
    function x() {
      return y.value && y.value.validate() ? {
        action: Y.Signin,
        emailAddress: n.value
      } : !1;
    }
    function d() {
      return {
        action: Y.Resend
      };
    }
    function T() {
      var U;
      return ((U = h.value) == null ? void 0 : U.length) === 6 ? {
        action: Y.Validation,
        code: h.value
      } : !1;
    }
    const D = () => {
      a.value = !0, g(x);
    }, re = async () => {
      await g(d), c.value = !0;
    }, ue = () => {
      g(T);
    }, de = () => {
      c.value = !1, _.value = !1, a.value ? L() : r(), a.value = !1;
    };
    return (U, K) => {
      var J;
      return f(), S("div", G(U.$attrs, { class: "thn--tool-signin" }), [
        l(c) ? (f(), S(Z, { key: 1 }, [
          M(xt, { onGoBack: de }, {
            default: Ve(() => [
              Ie(C(l(n)), 1)
            ]),
            _: 1
          }),
          v("header", Ut, [
            v("div", Zt, C(I.value), 1),
            v("p", null, C(E.value), 1)
          ]),
          M(Bt, {
            modelValue: l(h),
            "onUpdate:modelValue": K[2] || (K[2] = (Q) => pe(h) ? h.value = Q : null),
            onValidate: ue,
            onResendCode: re
          }, null, 8, ["modelValue"])
        ], 64)) : (f(), S(Z, { key: 0 }, [
          v("header", It, [
            v("div", Kt, C(u.value), 1)
          ]),
          v("div", Et, [
            M(ye, {
              class: "thn--tool-signin__input",
              ref_key: "emailRef",
              ref: y,
              type: "email",
              modelValue: l(n),
              "onUpdate:modelValue": K[0] || (K[0] = (Q) => pe(n) ? n.value = Q : null),
              placeholder: P.value,
              "error-message": m.value,
              disabled: !!p.value,
              required: !0,
              style: A(l(w)),
              id: "signin-email"
            }, null, 8, ["modelValue", "placeholder", "error-message", "disabled", "style"]),
            v("div", zt, [
              v("button", {
                type: "submit",
                tabindex: "0",
                class: "thn--tool-button",
                style: A(l(i)),
                "data-full-width": (J = l(b)) == null ? void 0 : J.fullWidth,
                onClick: D,
                onKeydown: ge(D, ["enter"])
              }, [
                K[3] || (K[3] = v("div", { class: "thn--tool-button__back" }, null, -1)),
                v("div", Ot, C(O.value), 1)
              ], 44, Nt),
              v("div", {
                class: "thn--tool-signin__signin",
                style: A(l(w))
              }, [
                v("span", null, C($.value), 1),
                v("a", {
                  href: "#",
                  onClick: K[1] || (K[1] = fe(
                    //@ts-ignore
                    (...Q) => l(r) && l(r)(...Q),
                    ["prevent", "stop"]
                  ))
                }, C(B.value), 1)
              ], 4)
            ])
          ])
        ], 64))
      ], 16);
    };
  }
}), jt = { class: "thn--tool-login__success" }, Wt = { class: "thn--tool-login__success__header" }, Gt = { class: "thn--tool-login__success__hello" }, Jt = { class: "thn--tool-login__success__email" }, Qt = /* @__PURE__ */ R({
  __name: "LoginSuccess",
  setup(t) {
    const e = q(), o = oe(), {
      emailValue: n,
      appearanceStyle: i
    } = o, h = s(() => e == null ? void 0 : e.literals.getLiteral("Hello")), b = s(() => e == null ? void 0 : e.literals.getLiteral("Exclusive benefits unlocked!"));
    return (c, _) => (f(), S("div", jt, [
      v("div", Wt, [
        v("p", Gt, C(h.value) + ", ", 1),
        v("p", Jt, C(l(n)), 1)
      ]),
      v("p", {
        class: "thn--tool-login__success__benefits",
        style: A(l(i))
      }, C(b.value), 5)
    ]));
  }
}), Xt = ["data-module-id"], ea = { class: "thn--tool-login__container" }, ta = /* @__PURE__ */ R({
  __name: "Login",
  props: {
    moduleProps: {}
  },
  setup(t) {
    const e = t, o = {
      [N.LoginRegister]: Tt,
      [N.LoginSignin]: Yt,
      [N.LoginSuccess]: Qt
    }, n = oe(), {
      initModule: i,
      updateModule: h,
      currentStep: b
    } = n;
    return Ke(() => e.moduleProps, () => {
      h(e.moduleProps);
    }), W(() => {
      i(e.moduleProps);
    }), (c, _) => {
      var w;
      return f(), S("div", {
        class: "thn--tool-login",
        "data-module-id": (w = e.moduleProps) == null ? void 0 : w.id
      }, [
        v("div", ea, [
          M(Ee, {
            name: "fade",
            mode: "out-in"
          }, {
            default: Ve(() => [
              (f(), _e(Ae(o[l(b)])))
            ]),
            _: 1
          })
        ])
      ], 8, Xt);
    };
  }
}), aa = /* @__PURE__ */ Se(ta, [["__scopeId", "data-v-2b30174c"]]), na = ["can-animate", "aria-label"], oa = ["state", "data-add-module", "data-vertical-center", "data-image-position", "inert"], _a = /* @__PURE__ */ R({
  __name: "Steps",
  props: {
    steps: {},
    hasExtraSteps: {},
    maxHeight: {},
    toolKind: {},
    layoutKind: {},
    layout: {},
    imagePosition: {}
  },
  setup(t) {
    he((a) => ({
      fff92da4: w.value
    }));
    const { t: e } = je(), o = {
      [V.Heading]: Pe,
      [V.Paragraph]: Pe,
      [V.SavedSearch]: $e,
      [V.EmailCapture]: $e,
      [V.Button]: Ge,
      [V.Perks]: st,
      [V.Countdown]: mt,
      [V.Form]: vt,
      [V.Spacer]: _t,
      [V.Login]: aa
    }, n = q(), i = t, h = k(), b = s(() => {
      var a;
      return (a = h.value) == null ? void 0 : a.querySelector(`.thn--tool-steps__step--${n == null ? void 0 : n.handlers.stepActive}`);
    }), c = s(() => Object.keys(i.steps)), { height: _ } = Ye(b), w = s(() => i.toolKind === Le.Inliner ? "0" : "100%"), L = s(() => {
      let a = parseInt((n == null ? void 0 : n.styles.getCssVariableValue("--step-padding")) || "10", 10);
      a = i.layoutKind === X.LowerNotification ? a * 2 + 5 : a;
      let p = _.value + 2 * a;
      return i.maxHeight && (p = Math.min(i.maxHeight, p)), {
        height: i.layoutKind === X.SquareImage && i.toolKind !== Le.Inliner ? "100%" : H(p),
        overflowY: n != null && n.handlers.isFirstStep ? "auto" : "hidden"
      };
    }), r = s(() => {
      let a;
      return _.value < 320 ? a = _.value : _.value >= 320 && _.value < 450 ? a = _.value + _.value * 0.35 : _.value >= 450 && _.value < 650 ? a = _.value + _.value * 0.55 : a = _.value + _.value * 0.65, {
        height: H(a)
      };
    });
    function g(a) {
      return o[a] || "div";
    }
    function y(a) {
      switch (!0) {
        case (n == null ? void 0 : n.handlers.stepActive) === a:
          return ee.Active;
        case (n == null ? void 0 : n.handlers.stepPrevious) === a:
          return ee.Previous;
        default:
          return ee.Next;
      }
    }
    return W(() => {
      Je.value = h.value;
    }), (a, p) => {
      var u;
      return f(), S("div", {
        class: "thn--tool-steps",
        ref_key: "rootDom",
        ref: h,
        style: A(L.value),
        "can-animate": !((u = l(n)) != null && u.handlers.isFirstStep),
        "data-testid": "steps",
        "aria-label": l(e)("Main content")
      }, [
        a.layoutKind === l(X).SquareImage && a.imagePosition === "top" ? (f(), S("div", {
          key: 0,
          class: "thn--tool-steps__container",
          style: A(r.value)
        }, null, 4)) : j("", !0),
        (f(!0), S(Z, null, te(c.value, (m) => {
          var P;
          return f(), S("section", {
            class: ve(`thn--tool-steps__step thn--tool-steps__step--${m}`),
            state: y(m),
            key: m,
            "data-add-module": m === l(se).Main && m === ((P = l(n)) == null ? void 0 : P.handlers.stepActive),
            "data-vertical-center": a.layoutKind === l(X).SquareImage && m === "main",
            "data-image-position": a.imagePosition,
            inert: y(m) !== l(ee).Active
          }, [
            (f(!0), S(Z, null, te(a.steps[m], ($, B) => (f(), _e(Ae(g($.moduleType)), G({
              class: "thn--tool-steps__step-component",
              key: B,
              "has-extra-steps": a.hasExtraSteps,
              "aria-live": a.hasExtraSteps ? "assertive" : "off",
              layout: a.layout,
              ref_for: !0
            }, {
              moduleProps: $
            }), null, 16, ["has-extra-steps", "aria-live", "layout"]))), 128))
          ], 10, oa);
        }), 128))
      ], 12, na);
    };
  }
});
export {
  ee as S,
  _a as _,
  z as c
};
//# sourceMappingURL=Steps.vue_vue_type_style_index_0_lang.BZiYBok5.js.map
